export default __webpack_public_path__ + "static/media/net-ent.4c1023b3.webp";